import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import 'react-phone-number-input/style.css';
import './phone.css';

import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import LuxService from '../../services/LuxService';
import { ErrorPopUp } from '../../components/ErrorPopUp';
const getCountryCode = (v) => {
  switch (v) {
    case 'france': {
      return { letters: 'FR', code: '+33' };
    }
    case 'germany': {
      return { letters: 'DE', code: '+49' };
    }
    case 'luxembourg': {
      return { letters: 'LU', code: '+352' };
    }
    case 'belgium': {
      return { letters: 'BE', code: '+32' };
    }
    default: {
      return '';
    }
  }
};

function PhoneNumberPage() {
  const { t, i18n } = useTranslation();
  const {
    steps,
    currentStep,
    data,
    setData,
    setCurrentStep,
    trackEvent,
    flowNumber,
  } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    if (!isValidPhoneNumber(data?.phonenumber + ''))
      setData({ ...data, errors: { ...data?.errors, phonenumber: true } });
    else {
      setIsLoading(true);
      try {
        if (flowNumber === 1) {
          const response = await LuxService.resetPhoneNumberValidation(
            data?.phonenumber,
            i18n.language
          );
          if (!response?.pinId?.length) throw new Error({ code: 102 });

          setData({
            ...data,
            pinId: response?.pinId,
            smsCodeSentCount: data?.smsCodeSentCount + 1,
          });
        }
        else if (flowNumber+'' === '2') {
          let response = await LuxService.isPhoneReturning(data?.phonenumber, 2);
          if(response?.is_returning){
            throw {code: 1002};
          }
           response = await LuxService.isPhoneReturning(data?.phonenumber, 3);
          if(response?.is_returning){
            throw {code: 1002};
          }
            response = await LuxService.isPhoneReturning(data?.phonenumber, 1);
          if(response?.is_returning){
            throw {code: 1002};
          }
        }

        setCurrentStep(currentStep + 1);
      } catch (err) {
        console.log('err', err);
        setData({
          ...data,
          errors: { ...data?.errors, phonenumber:err?.code? err?.code:true },
        });
      } finally {
        setIsLoading(false);
      }
    }
  };
  const inputRef = useRef(null);
  useEffect(() => {
    trackEvent({ nav_to_number: 1 });
  }, [trackEvent]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isValidPhoneNumber(data?.phonenumber + '')) {
      onSubmit();
    }
  };

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
        pointerEvents: isLoading ? 'none' : 'all',
      }}
    >
      <Header steps={steps} currentStep={currentStep} />
      <ErrorPopUp
        errorText={
            t('errors.' + data?.errors?.phonenumber)
          }
        error={data?.errors?.phonenumber}
        setError={(v) =>
          setData({ ...data, errors: { ...data?.errors, phonenumber: v } })
        }
      />
      <div
        style={{
          marginTop: '83px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
        }}
      >
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
          }}
        >
          {t('phoneNumberPage.title')}
        </Typography>
        <Box sx={{ marginTop: '48px' }}>
          <div
            className={!data?.isOtherCountry ? 'other-country' : 'country'}
            style={{
              background: 'white',
              borderRadius: '4px',
              border: '',
              padding: '13px',
              paddingInline: '16px',
              position: 'relative',
              overflowX: 'hidden !important',
            }}
          >
            {!!data?.isOtherCountry && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '26px',
                  position: 'absolute',
                  borderRight: '1px solid #E5E5E5',
                  paddingRight: '10px',
                  paddingLeft: '8px',
                  left: '41px',
                  top: '13px',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#808185',
                }}
              >
                {getCountryCode(data?.country)?.code}
              </div>
            )}

            <PhoneInput
              countryCallingCodeEditable={true} // Allow manual deletion of the country code
              withCountryCallingCode={true} // Show country calling code
              value={data?.phonenumber}
              inputRef={inputRef}
              autoFocus
              inputMode="numeric"
              onKeyDown={handleKeyDown}
              onChange={(value) => {
                console.log('oldvalue', data?.phonenumber);
                console.log('newvalue', value);
                setData({
                  ...data,
                  phonenumber: value,
                  errors: { ...data?.errors, phonenumber: false },
                });
              }}
              defaultCountry="LU" // Default country as Luxembourg
            />
          </div>
        </Box>
        {flowNumber === 1 && (
          <div style={{ marginTop: '40px', paddingInline: '7px' }}>
            <Typography
              sx={{ fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              {t('phoneNumberPage.text')}
            </Typography>{' '}
          </div>
        )}
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <button
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
            style={{
              outline: 'none',
              border: 'none',
              borderRadius: '50%',
              width: '57px',
              height: '57px',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
            >
              <rect
                opacity="0.1"
                width="57"
                height="57"
                rx="28.5"
                transform="matrix(-1 0 0 1 57 0)"
                fill="#44546A"
              />
              <path
                d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                stroke="#44546A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <PrimaryButton
            style={{ flex: 1 }}
            disabled={!isValidPhoneNumber(data?.phonenumber + '')}
            onClick={onSubmit}
            isLoading={isLoading}
          >
            {t('continue')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default PhoneNumberPage;
